/* unplugin-vue-components disabled */import { render } from "./KilaKilaFormCard.vue?vue&type=template&id=5f998c5b&scoped=true"
import script from "./KilaKilaFormCard.vue?vue&type=script&lang=js"
export * from "./KilaKilaFormCard.vue?vue&type=script&lang=js"

import "./KilaKilaFormCard.vue?vue&type=style&index=0&id=5f998c5b&scoped=true&lang=css"

import exportComponent from "/Users/zhaoxu/Documents/development.localized/public.localized/github/KilaKila-Blog/kilakila-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f998c5b"]])

export default __exports__